import { Form, Upload } from 'antd';
import styled from 'styled-components';

export const StyledForm = styled(Form)`
  p {
    font-size: 1.125rem;
    font-weight: inherit;
    margin-bottom: .75rem;
  }
`;

export const StyledFormUpload = styled(Upload.Dragger)`
  .ant-upload {
    width: 100% !important;
    min-height: 200px;
  }
`;